import React from 'react';
import { useMediaQuery } from 'react-responsive';
import AgenticCommerceContent from './AgenticCommerceContent';

const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 768 });
  return isDesktop ? children : null;
};

const DesktopResponsive = ({ history }) => (
  <Desktop>
    <AgenticCommerceContent history={history} />
  </Desktop>
);

export default DesktopResponsive;
